import { ConfigStore } from "../config/config";

export function defineOfficeRoamingConfigStore<T>(key: string): ConfigStore<T> {
    return {
        load: async () => {
            return Office.context.roamingSettings.get(key);
        },
        save: async (config?: T) => {
            if (config === undefined) Office.context.roamingSettings.remove(key);
            else Office.context.roamingSettings.set(key, config);
            
            void Office.context.roamingSettings.saveAsync();
        }
    }
}
